import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import './OcrImagePickerModal.scss';

export interface OcrImageDisplayModalProps {
  imageSrc: string | null;
  onClose: () => void;
  onBack: () => void;
  onUse: () => void;
  isFromCamera?: boolean;
}

export default function OcrImageDisplayModal({ imageSrc, onClose, onBack, onUse, isFromCamera = false }: OcrImageDisplayModalProps) {
  const [useLoading, setUseLoading] = useState(false);

  if (!imageSrc) {
    return null;
  }

  const handleUse = async () => {
    setUseLoading(true);
    try {
      await onUse();
    } finally {
      setUseLoading(false);
    }
  };

  return (
    <div className="ocr-panel">
      <div className="ocr-header">
        <div className="ocr-header-actions" style={{ marginLeft: 'auto' }}>
          <Button className="ocr-close-button" onClick={onClose}>
            Close
          </Button>
          <Button className="ocr-back-button" onClick={onBack}>
            {isFromCamera ? 'Take a new photo' : 'Choose a new image'}
          </Button>
          <Button className="ocr-use-button" primary loading={useLoading} onClick={handleUse}>
            Use this image
          </Button>
        </div>
      </div>
      <div className="ocr-image-content">
        <img src={imageSrc} alt="OCR Preview" className="ocr-image" />
      </div>
    </div>
  );
}
